import {createAction, props} from '@ngrx/store';
import {AppClass} from '../classes/app-class';

export const setActiveAppClasses: any = createAction(
  '[Set] Active App Classes',
  props<{ activeAppClasses: AppClass[] }>()
);
